const SUCCESS_STATUSES = ['issued', 'paid', 'approved', 'authorized'];
const PROCESSING_STATUSES = ['pending_contingency', 'pending_review_manual'];

export default {
  async create({ cart, token, customer }) {
    const { email, name } = customer || {};

    try {
      return email
        ? await Thor.GuestOrders.create(
            {},
            { data: { cart, user: { name, email }, challenges: { token } } }
          )
        : await Thor.Order.create({}, { data: { cart } });
    } catch (err) {
      const { response } = err;

      if (
        response?.status === 422 &&
        response?.responseJSON?.error === 'Cart not found for user'
      ) {
        throw new Error('Cart not found');
      }

      err.errors = response?.responseJSON?.errors;
      throw err;
    }
  },

  async pay(orderNumber, paymentForm = {}, isTrial = false) {
    const email = paymentForm?.customer?.email;

    try {
      const payment = isTrial
        ? await Thor.TrialPlans.create(
            {},
            { data: { attributes: paymentForm } }
          )
        : email
        ? await Thor.GuestOrdersPayments.create(
            { order_number: orderNumber },
            { data: paymentForm }
          )
        : await Thor.Order.pay(
            { order_number: orderNumber },
            { data: paymentForm }
          );

      const selectPaymentType = paymentForm.payment.type;

      const paymentTypes = {
        CreditCardPayment: payment.credit_card_payment || payment.payment,
        PixPayment: payment.pix_payment,
        TicketPayment: payment.ticket_payment,
        BnplPayment: payment.bnpl_payment
      };

      const usedPayment = paymentTypes[selectPaymentType];

      // Nupay fallback
      const nupayFallbackAllowed =
        gon.fallback_nubank &&
        paymentForm?.card?.bank === 'nubank' &&
        usedPayment?.status === 'rejected';

      if (nupayFallbackAllowed) {
        return payment;
      }

      if (
        !SUCCESS_STATUSES.includes(usedPayment.status) &&
        !PROCESSING_STATUSES.includes(usedPayment.status_detail)
      ) {
        const err = new Error(
          usedPayment[
            gon.flags.modal_error_checkout
              ? 'status_detail'
              : 'gateway_issue_message'
          ]
        );
        err.alert = true;
        throw err;
      }

      return payment;
    } catch (err) {
      const { response } = err;
      err.errors = response?.responseJSON?.errors;
      throw err;
    }
  }
};
